import React, { createContext, useCallback, useContext, useReducer } from 'react'
import { TimedAlert } from '../timedAlert'

export const NotificationContextClass = createContext(null)


export function NotificationContext({
  children,
  value
}) {
  const [state, dispatch] = useReducer(notificationReducer, value || { queue: [] })

  const displayNotif = useCallback((variant, message, timeout) => {
    dispatch({ type: 'add-notification', payload: { variant, message, timeout } })

  }, [dispatch])

  function nextMessage() {
    dispatch({ type: 'next-message' })
  }
  return (
    <>
      <NotificationContextClass.Provider value={displayNotif}>
        {children}
      </NotificationContextClass.Provider>
      <TimedAlert state={state} nextMessage={nextMessage} />
    </>

  )
}

export function useNotificationContext() {
  return useContext(NotificationContextClass)
}



function notificationReducer(state, action) {
  switch (action.type) {
    case 'next-message':
      return {
        ...state,
        queue: state.queue.slice(1)
      }
    case 'add-notification':
      return {
        ...state,
        queue: [...state.queue, action.payload]
      }
    default:
      console.warn('notification default reducer switch')
      break;
  }
  return state
}